import { JobsXingletWrapper } from '../../../jobs-xinglet';
import { JobsRecommendationsSkeletons } from '../shared-components/skeletons';

export const TopEmployers = JobsXingletWrapper(
  '@xing-com/crate-jobs-domain-recommendations-top-employers',
  <JobsRecommendationsSkeletons dataTestId="top-employers-skeleton" />
);
